import React from 'react';
import classNames from 'classnames';
import s from './custom-video-player.module.scss';

/** Круглая кнопка контролов плеера (прозрачная, с hover-фоном) */
export const PlayerIconButton = ({ className, onClick, ariaLabel, children }) => (
	<button type="button" className={classNames(s.iconButton, className)} onClick={onClick} aria-label={ariaLabel}>
		{children}
	</button>
);
